import { TableName } from "../../../../../tables"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { PaymentTypeList } from "./paymentTypeList"

export const PaymentTypeListLoader = () => (
    <ListLoaderWrapper table={TableName.PAYMENT_TYPES}>
        <PaymentTypeList />
    </ListLoaderWrapper>
)
